<template>
  <Menu.Root v-if="current" id="switch-newsletter">
    <Menu.Trigger>
      <button
        type="button"
        class="flex min-w-0 select-none items-center gap-1.5 rounded-md px-2 py-1 text-sm font-semibold text-gray-800 outline-2 outline-blue-500 transition hover:bg-gray-200 focus-visible:outline active:bg-gray-200 data-[state=open]:bg-gray-200 dark:text-white dark:hover:bg-card dark:data-[state=open]:bg-card"
      >
        <NewsletterIcon :newsletter="current" class="-ml-1" />

        <span class="truncate">{{ current.name }}</span>
      </button>
    </Menu.Trigger>

    <Menu.Container>
      <div v-if="newsletters.length > 5" class="mb-2 px-1 pt-1">
        <div class="relative flex items-center">
          <Form.TextInput
            v-model="searchQuery"
            type="text"
            placeholder="Search newsletters..."
            @click.stop
            @keydown.stop
            @keyup.stop
          />
        </div>
      </div>

      <Draggable v-model="newsletters">
        <Menu.CheckboxItem
          v-for="item in filteredNewsletters"
          :key="item.id"
          :model-value="item.id === current.id"
          :index="newsletters.findIndex((n) => n.id === item.id)"
          :label="item.name || item.username"
          :class="{
            'opacity-50': item.status === 'dormant',
          }"
          @update:model-value="accountStore.switchNewsletter(item.id)"
        >
          <template #icon>
            <NewsletterIcon :newsletter="item" />
          </template>
        </Menu.CheckboxItem>
      </Draggable>

      <Menu.RouteItem
        label="Add Newsletter"
        :to="{ name: '/settings/danger-zone/add-newsletter' }"
      >
        <template #icon>
          <PlusIcon class="size-5 rounded-md bg-muted p-1 text-foreground" />
        </template>
      </Menu.RouteItem>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import Form from "@/design_system/Form";
import Menu from "@/design_system/Menu";
import PlusIcon from "@/icons/heroicons/plus-micro.svg";
import Draggable from "@/lib/pragmatic-dnd/Draggable.vue";
import { useAccountStore, useNewsletter } from "@/store/stores/account";

import { useSortableNewsletters } from "./lib";
import NewsletterIcon from "./NewsletterIcon.vue";

const accountStore = useAccountStore();

const current = useNewsletter();

const newsletters = useSortableNewsletters();
const searchQuery = ref("");

const filteredNewsletters = computed(() => {
  if (!searchQuery.value.trim()) {
    return newsletters.value;
  }

  const query = searchQuery.value.toLowerCase().trim();
  return newsletters.value.filter((newsletter) => {
    const name = (newsletter.name || newsletter.username || "").toLowerCase();
    return name.includes(query);
  });
});
</script>
